<template>
  <div>
    <div class="d-flex align-center">
      <h3>SKU's mais vendidos</h3>
      <v-spacer></v-spacer>
    </div>

    <v-divider class="ma-2"></v-divider>
    <v-data-table
      :items="skuSales"
      :loading="skuloading"
      :headers="skuHeaders"
      class="content-table"
      hide-default-footer
      loading-text="Buscando..."
      no-data-text="Sem registros"
    >
      <template v-slot:[`item.salesValue`]="{ item }">
        {{
          item.salesValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        }}
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="totalPages"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "SkusDashResale",
  components: {Pagination},

  props: {
    filter: {
      resaleId: "",
      startDate: "",
      endDate: "",
    },
  },

  data() {
    return {
      skuSales: [],
      page: 1,
      pageSize: 10,
      currentPage: 1,
      totalItems: 1,
      totalPages: 1,
      skuHeaders: [
        {
          text: "Produto",
          align: "center",
          value: "product",
        },
        {
          text: "Atributo",
          align: "center",
          value: "attribute",
        },
        {
          text: "Quantidade",
          align: "center",
          value: "salesQuantity",
          sortable: false,
        },
        {
          text: "Valor",
          align: "center",
          value: "salesValue",
        },
      ],
      headerProps: {
        sortByText: "Ordenar por",
      },

      skuloading: false,
      apiService: new ApiService(),
    };
  },

  created() {
    this.getSkuSales();
  },

  methods: {
    getSkuSales() {
      this.skuloading = true;
      this.apiService
        .post("dashresale/skus", { ...this.filter, page: this.page })
        .then((response) => {
          this.skuSales = response.content.data;
          this.totalPages = response.content.pager.totalPages;
          this.currentPage = response.content.pager.currentPage;
          this.totalItems = response.content.pager.totalItems;
          this.skuloading = false;
        })
        .catch(() => {
          this.skuloading = false;
        });
    },

    async backPage() {
      this.page -= 1;
      await this.getSkuSales();
    },

    async nextPage() {
      this.page += 1;
      await this.getSkuSales();
    },
  },

  watch: {},
};
</script>

<style></style>
